import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import "normalize.css"; // 重置样式
import "@/assets/sass/global.scss"; // 全局样式
// 引入 Vant 组件和样式
import {
  Swipe,
  SwipeItem,
  Form,
  Icon,
  Field,
  CellGroup,
  Checkbox,
  CheckboxGroup,
  Button,
} from "vant";
import "vant/lib/index.css";
// 引入 Element Plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
// 引入 Element Plus 图标
import * as ElementPlusIconsVue from "@element-plus/icons-vue";

// 引入路由对象
import router from "./router";

// 引入 i18n 国际化配置
import i18n from "./i18n";

// 引入 Pinia store

const app = createApp(App);

// 创建 Pinia 实例
const pinia = createPinia();

// 使用 Vant 组件
app.use(Swipe);
app.use(SwipeItem);
app.use(Icon);
app.use(Field);
app.use(Form);
app.use(CellGroup);
app.use(Checkbox);
app.use(CheckboxGroup);
app.use(Button);

// 处理 URL 中的 hash 符号
// if (window.location.hash) {
//   const path = window.location.hash.replace(/^#/, "");
//   history.replaceState(null, "", path);
// }
// 使用路由
app.use(router);

// 使用 i18n
app.use(i18n);

// 使用 Pinia store
app.use(pinia);

// 使用 Element Plus 图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

// 动态设置页面标题
app.mixin({
  watch: {
    "$i18n.locale": {
      handler() {
        document.title = this.$t("system.title");
      },
      immediate: true,
    },
  },
});

// 挂载应用
app.mount("#app");
